import React from 'react'

import SearchResultBody from './searchResultBody'
import Pagination from '../../../components/pagination/pagination'
import { getConfigBySite } from '../../../../../config/sites'

import styles from '../searchContentSection.module.css'

const SearchResults = ({
  baseUrl,
  results,
  location,
  currentSite,
  locationParams,
  makeSearchLink
}) => {
  const totalHits = results.total_hits
  const matches = results.matches
  const haveResults = !!(matches && matches.length)
  const showPagination = totalHits > 0
  const pageSize = getConfigBySite(currentSite, 'common.search_page_size')
  const maxPagesCount = getConfigBySite(currentSite, 'common.max_pages_count')

  return (
    <div className={styles.resultContainer} data-test-selector="search-results">
      {haveResults && (
        <SearchResultBody location={location} matches={matches} />
      )}
      {showPagination && (
        <Pagination
          currentPage={Number(location.query.page) || 1}
          currentSite={currentSite}
          totalItemsCount={totalHits}
          pageSize={pageSize}
          locationParams={locationParams}
          makeSearchLink={makeSearchLink}
          baseUrl={baseUrl}
          maxPagesCount={maxPagesCount}
        />
      )}
    </div>
  )
}

export default SearchResults
